/**
 * vjiang
 * 20200828153400
 * user management interface
 */
import request from '@/utils/request';

/**
 * 获取当前微信号维护的账号
 * @param openid
 */
export function getUser(params) {
    return request({
        url: '/business/MagUser/getInfo',
        method: 'get',
        params: params
    })
}

/**
 * 编辑用户信息
 * @param openid
 */
export function updateUser(data) {
    return request({
        url: '/business/MagUser/update',
        method: 'post',
        data: data
    })
}

/**
 * 删除当前微信号账户
 * @param params
 */
export function delUser(params) {
    return request({
        url: '/business/MagUser/unbind',
        method: 'get',
        params: params
    })
}

/**
 * 当前微信号添加体检账号
 * @param data
 */
export function addUser(data) {
    return request({
        url: '/business/MagUser/bind',
        method: 'post',
        data: data
    })
}